import { combineReducers, createReducer } from '@reduxjs/toolkit';

import {
  garageCleanupRequested,
  removalFromGarageRequested,
  replaceVehicleValue,
  vehicleDiscardingRequested,
} from 'Core/actions/fitmentSearch/index';
import { updateVehicleSelection } from 'Models/vehicle';

import { getInitialVehicleSelection } from '../common';

export default combineReducers({
  selection: createReducer(getInitialVehicleSelection(), (builder) =>
    builder
      .addCase(garageCleanupRequested, () => [])
      .addCase(vehicleDiscardingRequested, () => [])
      .addCase(removalFromGarageRequested, (state, { meta }) => (meta.wasSelected ? [] : state))
      .addCase(replaceVehicleValue, (state, { payload, meta: { fitmentFields } }) =>
        updateVehicleSelection(state, payload, fitmentFields),
      ),
  ),
});
